import React from "react";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import get from "lodash.get";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import CommonUtils from "services/common/utils";
import Table from "components/Table";

const styles = {
  tableRow: {
    cursor: "pointer",
  },
  displayNone: {
    display: "none",
  },
  tableColumn: {
    fontSize: "10px",
  },
  tableRowSelected: {
    backgroundColor: "#BDC3C7",
  },
  duration: {
    fontWeight: "bold",
    fontSize: "12px",
  },
};

class NonMovingCarsTable extends React.PureComponent {
  state = { selectedIndex: null };

  componentDidUpdate = (previousProps) => {
    if (
      previousProps.nonMovingCars.selectedIndex !==
      this.props.nonMovingCars.selectedIndex
    ) {
      this.setState({ selectedIndex: this.props.nonMovingCars.selectedIndex });
    }
  };

  handleRowSelection = (selectedIndex) => {
    if (this.state.selectedIndex === selectedIndex) {
      this.props.onRowSelection(null);
      this.setState({ selectedIndex: null });
    } else {
      this.props.onRowSelection(selectedIndex);
      this.setState({ selectedIndex });
    }
    return selectedIndex;
  };

  handleRowHover = (rowNumber) => {
    this.props.onRowHover(rowNumber);
  };

  handleRowHoverExit = (rowNumber) => {
    this.props.onRowHover(null);
  };

  getTableRowStyle = (index, typeSpot) => {
    if (typeSpot === "unavailable") {
      return styles.displayNone;
    }
    if (index === null) {
      return styles.tableRow;
    }

    const otherStyle =
      this.state.selectedIndex === index ? styles.tableRowSelected : {};
    return { ...styles.tableRow, ...otherStyle };
  };

  renderTableContent = () => {
    const { intl, nonMovingCars } = this.props;

    return get(nonMovingCars, "items", []).map((nonMovingCar, index) => {
      const areaTypeTradKey = get(nonMovingCar, "meta_data.area.type");
      const typeSpot = get(nonMovingCar, "type");

      return (
        <TableRow
          hover
          onClick={() => this.handleRowSelection(index)}
          style={this.getTableRowStyle(index, typeSpot)}
          onMouseOver={(e) => this.handleRowHover(index)}
          onMouseLeave={() => this.handleRowHover(null)}
          key={index}
        >
          <TableCell style={styles.tableColumn}>
            {CommonUtils.formatTime(nonMovingCar.arrival_time)}
          </TableCell>
          <TableCell style={{ ...styles.tableColumn, ...styles.duration }}>
            {CommonUtils.formatDuration(nonMovingCar.duration)}
          </TableCell>
          <TableCell style={styles.tableColumn}>
            {areaTypeTradKey && intl.messages[`area.type.${areaTypeTradKey}`]}
          </TableCell>
        </TableRow>
      );
    });
  };

  render() {
    const { intl, nonMovingCars, setOrders } = this.props;

    return (
      <Table
        loading={!get(nonMovingCars, "initialized")}
        headItems={{
          arrival_time:
            intl.messages["nonMovingCarsScene.table.header.arrived"],
          duration: intl.messages["nonMovingCarsScene.table.header.time"],
          "meta_data.area.type":
            intl.messages["nonMovingCarsScene.table.header.areaType"],
        }}
        sortable={{
          orders: get(nonMovingCars, "orders", {}),
          changeSort: setOrders,
        }}
        items={get(nonMovingCars, "items", [])}
      >
        {this.renderTableContent()}
      </Table>
    );
  }
}

NonMovingCarsTable.propTypes = {
  nonMovingCars: PropTypes.object.isRequired,
  onRowHover: PropTypes.func.isRequired,
  onRowSelection: PropTypes.func.isRequired,
  setOrders: PropTypes.func.isRequired,
};

export default injectIntl(NonMovingCarsTable);
